export const handleJsonError = (jsonString: string): object | null => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error('Invalid JSON:', e);
    return null;
  }
};
